import { useMutation } from 'react-query';
import { bindQuote } from '../api';

interface PostBindPayload {
  quoteId: string;
  paymentInterval?: string;
  agencyExternalId?: string;
  producerExternalId?: string;
}

interface PostBindPayloadStripe extends PostBindPayload {
  tokenId: string;
}

export const usePostBindQuote = (options?: any) => {
  return useMutation((payload: PostBindPayloadStripe) => bindQuote(payload), options);
};
